import defaultTheme from '../theme/primary';

export default function (theme: ReturnType<typeof defaultTheme>) {
    return {
        ...theme,
        width: '100%',
    };
}
